"use client";

import Link from "next/link";
import ReactECharts from 'echarts-for-react';
import { useRef, useEffect } from "react";
import Image from "next/image";
import btn_icon_diamond_png from "@/app/assets/common/btn_icon_diamond.png";

import type { EventDataType } from "./CardList"

export type MarketCardProps = {
  data: EventDataType
};

export const MarketCard: React.FC<MarketCardProps> = ({
  data,
  ...props
}) => {
  const chartRef = useRef(null)

  const chartData = data.priceTrend

  console.log("chartData :", chartData)
  // 从数据源中提取yAxisTicks
  const yAxisTicks = chartData?.yAxisTicks

  function generateOption(chartType: string) {
    return {
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        borderColor: '#eee',
        borderWidth: 1,
        textStyle: {
          color: '#fff'
        },
        formatter: function (params: any) {
          return `${params[0].name}<br/>${params[0].seriesName}: ${params[0].value}`;
        }
      },
      // legend: {
      //   data: [chartData.series[0].name],
      //   right: 10,
      //   top: 10,
      //   textStyle: {
      //     color: '#2c3e50'
      //   }
      // },
      grid: {
        left: '0%',
        right: '1%',
        bottom: '4%',
        top: '5%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: chartData.xAxis,
        axisLabel: {
          color: 'rgba(255,255,255,0.5)',
        },
        axisTick: { // 刻度线样式
          show: false
        },
        axisLine: {
          show: false
        },
        axisPointer: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        position: "right",
        min: yAxisTicks[0].value,  // 第一个刻度值作为最小值
        max: yAxisTicks[yAxisTicks.length - 1].value,  // 最后一个刻度值作为最大值
        interval: yAxisTicks[1].value - yAxisTicks[0].value,  // 计算刻度间隔
        axisLabel: {
          color: 'rgba(255,255,255,0.5)',
        },
        axisTick: {
          alignWithLabel: true,
          customValues: [60, 65, 70, 75, 80]
        },
        splitLine: { // 分割线样式
          show: true,
          lineStyle: {
            color: ['rgba(255,255,255,0.5)'], // 分割线颜色，可以设置成单个颜色，也可以设置成颜色数组实现交替颜色
            width: 1,
            type: 'dashed' // 分割线类型
          }
        },
        nameTextStyle: {
          color: 'rgba(255,255,255,0.5)'
        },
        axisLine: {
          show: false
        },
        axisPointer: {
          show: false
        }
      },
      series: [{
        name: chartData.series[0].name,
        type: chartType,
        data: chartData.series[0].data,
        smooth: true,
        showSymbol: false,
        lineStyle: {
          color: "#FFED41"
        }
        // areaStyle: chartType === 'area' ? {
        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     { offset: 0, color: 'rgba(52, 152, 219, 0.6)' },
        //     { offset: 1, color: 'rgba(52, 152, 219, 0.1)' }
        //   ])
        // } : null
      }],
      // dataZoom: [{
      //   type: 'inside',
      //   start: 0,
      //   end: 100
      // }]
    };
  }

  const handleResize = () => {
    if (chartRef.current) {
      // @ts-ignore
      // chartRef.current?.setOption(generateOption("line"))
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    // 清理事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  console.log("MarketCard1")

  if(!yAxisTicks) {
    return null
  }

  return (<div className='cardItem_race pt-20'>
    <div className='top-label'>{data.priceTrend.label}</div>
    <Link href={process.env.NODE_ENV === "development" ? data.market.eventLink.replace("https://askpaul.ai", '') : data.market.eventLink} className='flex items-center '>
      <Image
        src={data.market.image}
        alt={data.market.question} width="60" height="60"
        style={{ width: "6rem", height: "auto" }}
      />
      <div className='ml-10 text-bravve-200 font-bold text-15'>
        {data.market.question}
      </div>
    </Link>

    <ReactECharts option={generateOption("line")} style={{ height: '20rem' }} ref={chartRef} />

    <div className='mt-10 flex justify-between items-center'>

      <div className={'button_50p flex items-center justify-center font-semibold relative ' +
        (data.market.aiPrediction === data.market.outcomeName1 ? 'bg-bravve-100' : 'bg-bravve-200')}
      >
        {data.market.aiPrediction === data.market.outcomeName1 &&
          <span className='absolute text-10 text-bravve-300 font-black top-5 right-10 leading-12'>AI</span>}
        <span className='text-xs text-bravve-sub-400' >{data.market.outcomeName1}</span>
        <span className='text-xl ml-5 text-bravve-300' >{data.market.outcomePrice1}</span>
        <Image src={btn_icon_diamond_png} alt='btn_icon_diamond' width={20} height={20}
          style={{ height: '2rem', width: '2rem' }} />
      </div>

      <div className={'button_50p flex items-center justify-center font-semibold relative ml-10 ' +
        (data.market.aiPrediction === data.market.outcomeName2 ? 'bg-bravve-100' : 'bg-bravve-200')}
      >
        {data.market.aiPrediction === data.market.outcomeName2 &&
          <span className='absolute text-10 text-bravve-300 font-black top-5 right-10 leading-12'>AI</span>}
        <span className='text-xs text-bravve-sub-400' >{data.market.outcomeName2}</span>
        <span className='text-xl ml-5 text-bravve-300' >{data.market.outcomePrice2}</span>
        <Image src={btn_icon_diamond_png} alt='btn_icon_diamond' width={20} height={20}
          style={{ height: '2rem', width: '2rem' }} />
      </div>

    </div>
  </div>)
}